module.exports = __webpack_public_path__ + "img/fm-f-Path 58@3x.40247503.png";